export const ru = {
    'first-n-items-will-be-selected': {
        one: 'Будет выбрана {count} первая корректировка',
        some: 'Будут выбраны первые {count} корректировки',
        many: 'Будут выбраны первые {count} корректировок',
        none: 'Будут выбраны первые {count} корректировок'
    },
    'max-items-number-selected':
        'Выбрано максимальное количество корректировок',
    'more-than-max-items-number-selected': {
        one: 'Нельзя выбрать больше {count} корректировки',
        some: 'Нельзя выбрать больше {count} корректировок',
        many: 'Нельзя выбрать больше {count} корректировок',
        none: 'Нельзя выбрать больше {count} корректировок'
    },
    'no-results-text':
        'Убедитесь, что в запросе нет ошибок или попробуйте уменьшить длину запроса',
    'no-results-title': 'Ничего не найдено'
};
